/**
 * Yleiskuva → one quiet line on whether the backend, its database and the
 * RAG service answer. Polled every 30 s; an unreachable service says so.
 */
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import API_ENDPOINTS from '../../config/api';
import { useTranslation } from '../../hooks/useTranslation.jsx';

const Line = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 28px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
`;

const Dot = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${p => (p.$ok === null ? '#666' : p.$ok ? '#4ade80' : '#f87171')};
  }
`;

async function probe(url) {
  try {
    const res = await fetch(url);
    return res.ok ? await res.json() : null;
  } catch {
    return null;
  }
}

export default function ServiceHealth() {
  const { t } = useTranslation();
  const [state, setState] = useState({ backend: undefined, rag: undefined });

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const [backend, rag] = await Promise.all([probe(API_ENDPOINTS.BACKEND_HEALTH()), probe(API_ENDPOINTS.RAG_HEALTH())]);
      if (!cancelled) setState({ backend, rag });
    };
    run();
    const timer = setInterval(run, 30000);
    return () => { cancelled = true; clearInterval(timer); };
  }, []);

  const known = (v) => (v === undefined ? null : Boolean(v));
  return (
    <Line aria-label={t('adminHome.health')}>
      <Dot $ok={known(state.backend)}>{t('adminHome.backend')}</Dot>
      <Dot $ok={state.backend === undefined ? null : state.backend?.database?.status === 'connected'}>{t('adminHome.database')}</Dot>
      <Dot $ok={known(state.rag)}>{t('adminHome.rag')}</Dot>
    </Line>
  );
}
